module.exports = __webpack_public_path__ + "static/bamboo-fibre-mobile-bd8866c1d8cc1ba7f40aebc5c81c5bde.jpg";